import e from"styled-components";const o=e.div`
	display: flex;
	flex-direction: column;
	border: 0.71px solid ${({theme:e})=>e.border.black10};
	border-radius: ${({borderRadius:e})=>`${e}px`};
	height: 100%;
`,r=e.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
`,i=e.div`
	max-height: 105px;
	height: 100%;
	overflow: hidden;
	background-color: ${({theme:e})=>e.bg.atlassian};
	display: grid;
	border-top-left-radius: ${({borderRadius:e})=>`${e}px`};
	border-top-right-radius: ${({borderRadius:e})=>`${e}px`};
	place-content: space-evenly;
`,d=e.div`
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	border-bottom-left-radius: ${({borderRadius:e})=>`${e}px`};
	border-bottom-right-radius: ${({borderRadius:e})=>`${e}px`};
	background-color: ${({theme:e})=>e.bg.card};
	padding: 14px;
	position: relative;
	box-sizing: border-box;
	gap: ${({hasLabel:e})=>e?"32px":"0px"};
	height: 100%;
`,t=e.h1`
	margin: 0;
	font-size: 20px;
	color: ${({theme:e})=>"dark"===e.name?"#fff":"#0a326c"};
	font-weight: 500;
	max-width: 80%;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,a=e.p`
	margin: 0;
	color: ${({theme:e})=>"dark"===e.name?"#ffffff":"#0a326c"}80;
	font-size: 14px;
	line-height: 18px;
	white-space: pre-wrap;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,p=e.div`
	position: absolute;
	top: 16px;
	right: 14px;
`,l=e.span`
	background: ${({background:e})=>e};
	color: ${({color:e})=>e};
	border-radius: 9999px;
	padding: 5px 10px;
	font-size: 12px;
	display: inline-block;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`;export{p as CardArrowContainer,d as CardBodyContainer,o as CardContainer,r as CardContentContainer,t as CardHeading,i as CardIllustrationContainer,l as CardLabel,a as CardParagraph};
